import api from '@api';
import { call, put, takeEvery, select } from 'redux-saga/effects';
import {
    getReminderDetailFetchSuccess,
    getReminderDetailFetchFailure,
    createReminderDetailFetchSuccess,
    createReminderDetailFetchFailure,
    updateReminderDetailFetchSuccess,
    updateReminderDetailFetchFailure,
    cancelReminderDetailFetchSuccess,
    cancelReminderDetailFetchFailure,
    removeFromReminderAttendeesFetchSuccess,
    removeFromReminderAttendeesFetchFailure,
} from './reducer';
import { getRemindersListFetch } from '../remindersList/reducer';
import { ReminderDetailResType } from 'src/types/reminderDetail';
import { ReminderType } from 'src/types/reminder';
import translate from '@translate';
import { RootStoreType } from 'src/types/store';
import { RemindersListParamsType } from 'src/types/remindersList';

const getReminderDetailFetchRequest = async (idReminder: string) => {
    const res = await api('get', `api/secure/reminders/${idReminder}`);
    return res.data;
};

function* getReminderDetailFetch(action: { type: string; payload: string }) {
    try {
        const response: ReminderDetailResType = yield call((): any => getReminderDetailFetchRequest(action.payload));
        yield put(getReminderDetailFetchSuccess(response));
    } catch (error) {
        yield put(getReminderDetailFetchFailure({ error }));
    }
}

export function* getReminderDetailFetchWatch() {
    yield takeEvery('reminderDetail/getReminderDetailFetch', getReminderDetailFetch);
}

const createReminderDetailFetchRequest = async (data: ReminderType) => {
    const res = await api('post', 'api/secure/reminders', data);
    return res.data;
};

function* createReminderDetailFetch(action: { type: string; payload: ReminderType }) {
    try {
        const response: ReminderDetailResType = yield call((): any => createReminderDetailFetchRequest(action.payload));
        yield put(
            createReminderDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('reminders.message.reminderCreated') },
            })
        );
        const params: RemindersListParamsType = yield select((state: RootStoreType) => state.remindersList.params);
        yield put(getRemindersListFetch(params));
    } catch (error) {
        yield put(createReminderDetailFetchFailure({ error }));
    }
}

export function* createReminderDetailFetchWatch() {
    yield takeEvery('reminderDetail/createReminderDetailFetch', createReminderDetailFetch);
}

const updateReminderDetailFetchRequest = async (params: { idReminder: string; data: ReminderType }) => {
    const res = await api('put', `api/secure/reminders/${params.idReminder}`, params.data);
    return res.data;
};

function* updateReminderDetailFetch(action: { type: string; payload: { idReminder: string; data: ReminderType } }) {
    try {
        const response: ReminderDetailResType = yield call((): any => updateReminderDetailFetchRequest(action.payload));
        yield put(
            updateReminderDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('reminders.message.reminderUpdate') },
            })
        );
        const params: RemindersListParamsType = yield select((state: RootStoreType) => state.remindersList.params);
        yield put(getRemindersListFetch(params));
    } catch (error) {
        yield put(updateReminderDetailFetchFailure({ error }));
    }
}

export function* updateReminderDetailFetchWatch() {
    yield takeEvery('reminderDetail/updateReminderDetailFetch', updateReminderDetailFetch);
}

const cancelReminderDetailFetchRequest = async (idReminder: string) => {
    const res = await api('put', `api/secure/reminders/${idReminder}/cancel`);
    return res.data;
};

function* cancelReminderDetailFetch(action: { type: string; payload: string }) {
    try {
        const response: ReminderDetailResType = yield call((): any => cancelReminderDetailFetchRequest(action.payload));
        yield put(
            cancelReminderDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('reminders.message.reminderCanceled') },
            })
        );
        const params: RemindersListParamsType = yield select((state: RootStoreType) => state.remindersList.params);
        yield put(getRemindersListFetch(params));
    } catch (error) {
        yield put(cancelReminderDetailFetchFailure({ error }));
    }
}

export function* cancelReminderDetailFetchWatch() {
    yield takeEvery('reminderDetail/cancelReminderDetailFetch', cancelReminderDetailFetch);
}

const removeFromReminderAttendeesFetchRequest = async (idReminder: string) => {
    const res = await api('put', `api/secure/reminders/${idReminder}/removeFromAttendees`);
    return res.data;
};

function* removeFromReminderAttendeesFetch(action: { type: string; payload: string }) {
    try {
        const response: ReminderDetailResType = yield call((): any =>
            removeFromReminderAttendeesFetchRequest(action.payload)
        );
        yield put(
            removeFromReminderAttendeesFetchSuccess({
                ...response,
                messageSuccess: { title: translate('reminders.message.removedFromReminderAttendees') },
            })
        );
        const params: RemindersListParamsType = yield select((state: RootStoreType) => state.remindersList.params);
        yield put(getRemindersListFetch(params));
    } catch (error) {
        yield put(removeFromReminderAttendeesFetchFailure({ error }));
    }
}

export function* removeFromReminderAttendeesFetchWatch() {
    yield takeEvery('reminderDetail/removeFromReminderAttendeesFetch', removeFromReminderAttendeesFetch);
}
